/* eslint-disable import/prefer-default-export */

export const LTE_EXPIRED_CUSTOMERS = `https://slot.tizeti.com/geniatechapi/index.php`;
